// Light-only marketing, except these legal pages, which follow the theme.
export const LEGAL_ROUTES = new Set(["/terms", "/privacy"])
